import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import * as fa from '@fortawesome/free-solid-svg-icons';
import { Assignment } from 'src/app/classes/assignment';
import { AdsCampaign } from 'src/app/classes/ads-campaign';
import { AdsCampaignService } from 'src/app/services/ads-campaign.service';
import { AdsOrganization } from 'src/app/classes/ads-organization';
import { OrganizationService } from 'src/app/classes/organization.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
})

export class HomeComponent implements OnInit {

  adsOrganization: AdsOrganization;
  assignments: Assignment[] = [];
  adsCampaigns: AdsCampaign[] = [];

  fa = fa

  loaded = false

  constructor(
    private adsCampaignService: AdsCampaignService,
    private organizationService: OrganizationService
  ) { }

  ngOnInit(): void {
    this.organizationService.get().subscribe(adsOrganization => {
      this.adsOrganization = adsOrganization;
      this.loaded = true
    });

    this.adsCampaignService.search({}).subscribe(adsCampaigns => {
      this.adsCampaigns = adsCampaigns;
    });
  }  
}
